// extracted by mini-css-extract-plugin
module.exports = {"container":"TermCompanyAccountEdit_container__23spo","formContainer":"TermCompanyAccountEdit_formContainer__36xWh","buttons":"TermCompanyAccountEdit_buttons__2swBX"};